import React, { useState } from "react";
import { Button } from "../../button/button";
export const AddRecipe = () => {
  
  
  const [recipe, setRecipe] = useState();
  const handleChangeRecipe = (event) => {
    setRecipe(event.target.value);
  };
  const handleAddRecipe = async (event) => {
    event.preventDefault();
    // console.log(recipe);
    if (!recipe) return;

    setRecipe("");
    document.querySelectorAll("input").forEach((input) => {
      input.value = "";
    });
  };
  return (
    <form className="form-recipe">
      <label htmlFor="input-recipe-name">Recipe Name:</label>
      <input
        id="formRecipeName"
        onChange={handleChangeRecipe}
        className="form-input"
        type={"text"}
      ></input>
      <Button
        buttonText={"Submit"}
        handleClick={handleAddRecipe}
        styleClass={"btn btn-edit"}
      />
      {/* <input type={"submit"} onClick={handleAddRecipe}></input> */}
    </form>
  );
};
